import "./UpdateForm.scss";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Dots from "react-activity/dist/Dots";
import { CirclePicker } from "react-color";
import Button from "../components/Button";

function UpdateForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [nextPage, setNextPage] = useState(false);
  const [color, setColor] = useState("");
  const [picture, setPicture] = useState("");
  const [questionsArray, setQuestionsArray] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://tell-me-more-backend-nyfc.onrender.com/formById/${id}`
        );
        setData(response.data);
        setQuestionsArray(response.data.questionsArray);
        setColor(response.data.color);
        setPicture(response.data.pictureUrl);

        setIsLoading(false);
      } catch (error) {
        console.log(error.response);
      }
    };
    fetchData();
  }, [id]);

  const deleteForm = async (formId) => {
    const response = await axios.delete(
      `https://tell-me-more-backend-nyfc.onrender.com/form/delete/${formId}`
    );
    console.log(response.data);
    setData("");
  };

  const handleUpdateForm = async (e) => {
    e.preventDefault();
    if (questionsArray.length === 0) {
      alert("Votre formulaire doit contenir au moins une question");
    } else {
      let allFieldsAreFilled = true;
      for (let i = 0; i < questionsArray.length; i++) {
        if (questionsArray[i].question === "") {
          alert("Vos questions ne doivent pas être vides");
          allFieldsAreFilled = false;
          break;
        }
      }
      if (allFieldsAreFilled) {
        setIsLoading(true);
        const formData = new FormData();
        formData.append("picture", picture);
        formData.append("color", color);
        const stringifiedQuestionsArray = JSON.stringify(questionsArray);
        formData.append("questionsString", stringifiedQuestionsArray);

        const response = await axios.put(
          `https://tell-me-more-backend-nyfc.onrender.com/form/update/${id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(response.data);
        setIsLoading(false);
        alert("Votre formulaire a bien été sauvegardé");
        navigate(`/backoffice`);
      }
    }
  };

  return isLoading ? (
    <Dots />
  ) : (
    <div className="updateFormContainer">
      <div className="updateFormTop">
        <Link className="link" to={"/backoffice"}>
          Formulaires
        </Link>
        <div className="updateFormTitle">{data.title}</div>
        <div>
          <Button
            text={"Supprimer"}
            color={"red"}
            func={() => {
              deleteForm(id);
              alert("Formulaire supprimé");
              navigate("/backoffice");
            }}
            show={true}
          />
          <Button
            text={"Sauvegarder"}
            color={"green"}
            func={handleUpdateForm}
            show={true}
          />
        </div>
      </div>

      <div className="updateFormBottom">
        <div className="formUpdateNav">
          <nav
            className={nextPage === true ? "greenNav" : undefined}
            onClick={() => {
              setNextPage(false);
            }}
          >
            Questions
          </nav>
          <nav
            className={nextPage === false ? "greenNav" : undefined}
            onClick={() => {
              setNextPage(true);
            }}
          >
            Personnaliser le formulaire
          </nav>
        </div>
        {nextPage ? (
          <div className="nextPageContainer">
            <div className="circleDiv">
              <CirclePicker
                circleSize={80}
                colors={["#62C188", "#5D92BE", "#FF8138", "#B33FD6"]}
                onChange={(color) => setColor(color.hex)}
              />
              <p>Couleur du formulaire</p>
              <div
                className={
                  color === "#b33fd6"
                    ? "currentColor colorPurple"
                    : color === "#ff8138"
                    ? "currentColor colorOrange"
                    : color === "#5d92be"
                    ? "currentColor colorBlue"
                    : "currentColor colorGreen"
                }
              ></div>
            </div>
            <div>
              {picture === "no picture" ? (
                <div>
                  <label for="file" className="picFile">
                    Ajouter une image
                  </label>
                  <input
                    id="file"
                    className="input-file"
                    type="file"
                    onChange={(e) => setPicture(e.target.files[0])}
                  />
                </div>
              ) : (
                <div className="imageDiv">
                  {typeof picture === "string" ? (
                    <img className="image" src={picture} alt={""} />
                  ) : (
                    <img
                      className="image"
                      src={URL.createObjectURL(picture)}
                      alt={""}
                    />
                  )}
                  <Button
                    text={"Supprimer l'image"}
                    color={"red"}
                    func={() => {
                      setPicture("no picture");
                    }}
                    show={true}
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <div>
            <div className="questionsContainer">
              {questionsArray.map((item, index) => {
                return (
                  <div key={index} className="questionDiv">
                    <div
                      className={
                        item.category === 1
                          ? "iconDiv icon1"
                          : item.category === 2
                          ? "iconDiv icon2"
                          : item.category === 3
                          ? "iconDiv icon3"
                          : "iconDiv icon4"
                      }
                    >
                      {item.category} -{" "}
                    </div>
                    <input
                      type="text"
                      value={item.question}
                      onChange={(e) => {
                        const newQuestionsArray = [...questionsArray];
                        newQuestionsArray[index].question = e.target.value;
                        setQuestionsArray(newQuestionsArray);
                      }}
                    />
                    {index === 0 ? (
                      <Button
                        text={" ˄ "}
                        color={"grey"}
                        func={() => {}}
                        show={true}
                      />
                    ) : (
                      <Button
                        text={" ˄ "}
                        color={"white"}
                        func={() => {
                          const newQuestionsArray = [...questionsArray];
                          [
                            newQuestionsArray[index - 1],
                            newQuestionsArray[index],
                          ] = [
                            newQuestionsArray[index],
                            newQuestionsArray[index - 1],
                          ];
                          setQuestionsArray(newQuestionsArray);
                        }}
                        show={true}
                      />
                    )}
                    {index === questionsArray.length - 1 ? (
                      <Button
                        text={" ˅ "}
                        color={"grey"}
                        func={() => {}}
                        show={true}
                      />
                    ) : (
                      <Button
                        text={" ˅ "}
                        color={"white"}
                        func={() => {
                          const newQuestionsArray = [...questionsArray];
                          [
                            newQuestionsArray[index],
                            newQuestionsArray[index + 1],
                          ] = [
                            newQuestionsArray[index + 1],
                            newQuestionsArray[index],
                          ];
                          setQuestionsArray(newQuestionsArray);
                        }}
                        show={true}
                      />
                    )}
                    <Button
                      text={" X "}
                      color={"whitered"}
                      func={() => {
                        const newQuestionsArray = [...questionsArray];
                        newQuestionsArray.splice(index, 1);
                        setQuestionsArray(newQuestionsArray);
                      }}
                      show={true}
                    />
                  </div>
                );
              })}
            </div>
            <div className="createButtons">
              <Button
                text={"Ajouter une question Texte"}
                color={"lightgreen"}
                func={() => {
                  const newQuestionsArray = [...questionsArray];
                  newQuestionsArray.push({ question: "", category: 1 });
                  setQuestionsArray(newQuestionsArray);
                }}
                show={true}
              />
              <Button
                text={"Ajouter une question Note"}
                color={"lightgreen"}
                func={() => {
                  const newQuestionsArray = [...questionsArray];
                  newQuestionsArray.push({ question: "", category: 2 });
                  setQuestionsArray(newQuestionsArray);
                }}
                show={true}
              />
              <Button
                text={"Ajouter une question Email"}
                color={"lightgreen"}
                func={() => {
                  const newQuestionsArray = [...questionsArray];
                  newQuestionsArray.push({ question: "", category: 3 });
                  setQuestionsArray(newQuestionsArray);
                }}
                show={true}
              />
              <Button
                text={"Ajouter une question Oui/Non"}
                color={"lightgreen"}
                func={() => {
                  const newQuestionsArray = [...questionsArray];
                  newQuestionsArray.push({ question: "", category: 4 });
                  setQuestionsArray(newQuestionsArray);
                }}
                show={true}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UpdateForm;
